import { QuestionAndAnswersDTO } from "./question-and-answers.model";

export class QuizV2 { 
    quizId: number;
    storyName: string;
    storybookReadingLevel: string;
    questionAndAnswersDTO: [
        QuestionAndAnswersDTO
    ]
}